module.exports = __webpack_public_path__ + "static/why-vancity-6b0ad659f0f38ec720b0a04b72aa9ef6.png";